import { render, staticRenderFns } from "./UpdateGiftCard.vue?vue&type=template&id=8340f23e&scoped=true"
import script from "./UpdateGiftCard.vue?vue&type=script&lang=js"
export * from "./UpdateGiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8340f23e",
  null
  
)

export default component.exports